import { FC } from "react";

import { Button, Modal, ModalHeader, SpacingToken } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { InviteButton } from "components/payment-failures-limits/InviteButton";
import { PaymentFailedAlert, PaymentFailedLocation } from "components/payment-failures-limits/PaymentFailedAlert";
import { SeatsExceededMessage } from "components/payment-failures-limits/SeatsExceededMessage";
import { withVar } from "themes/helpers";

interface IProps {
  onModalClose: () => void;
  paymentFailed: boolean;
  onSubmit: () => void;
}

export const SubscriptionUpgradeModal: FC<IProps> = ({ onModalClose, paymentFailed, onSubmit }) => (
  <Modal
    title="Upgrade subscription"
    onClose={onModalClose}
    heading={<ModalHeader title="Upgrade subscription" />}
    footer={
      <Flex gap={withVar(SpacingToken.Spacing1)}>
        <Button onClick={onModalClose} kind="secondary">
          Cancel
        </Button>
        <InviteButton failed={paymentFailed} onSubmit={onSubmit} ignoreLimit />
      </Flex>
    }
  >
    <Flex column gap="16px" width="800px">
      <SeatsExceededMessage limitExceededBy={1} />
      {paymentFailed && <PaymentFailedAlert location={PaymentFailedLocation.RoleUpgrade} />}
    </Flex>
  </Modal>
);
